@if (menuItems().length > 0) {
  <div class="px-4 sm:px-6 py-2 flex items-center justify-between">
    <div class="flex items-center">
      <p-breadcrumb [model]="menuItemModels()">
        <ng-template #item let-crumbItem>
          @if (crumbItem.isSkeleton) {
            <p-skeleton width="80px" height="16px" borderRadius="4px" />
          } @else if (crumbItem.routerLink && !crumbItem.isLast) {
            <a
              [routerLink]="crumbItem.routerLink"
              class="text-primary hover:underline truncate max-w-[120px] md:max-w-none text-sm"
            >
              {{ crumbItem.label }}
            </a>
          } @else {
            <span
              class="text-slate-600 truncate max-w-[120px] md:max-w-none text-sm"
              [class.font-semibold]="crumbItem.isLast"
            >
              {{ crumbItem.label }}
            </span>
          }
        </ng-template>
        <ng-template #separator>
          <span class="text-slate-400 text-sm">/</span>
        </ng-template>
      </p-breadcrumb>
    </div>

    @if (rightTemplate(); as slotTemplate) {
      <ng-container [ngTemplateOutlet]="slotTemplate" />
    }
  </div>
}
